import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setCargoConsultaProvimentosServidores: ['cargo'],
    limpaFiltroConsultaProvimentosServidores: [],
    receberFiltroConsultaProvimentosServidores: ['filtroRecebido'],
    setStatusConsultaProvimentosServidores: ['status'],
})

const INITIAL_STATE = {
    cargo: '',
    status: { label: '', value: '' },
}

const setCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: action.cargo }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_CARGO_CONSULTA_PROVIMENTOS_SERVIDORES]: setCargo,
    [Types.LIMPA_FILTRO_CONSULTA_PROVIMENTOS_SERVIDORES]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_PROVIMENTOS_SERVIDORES]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_PROVIMENTOS_SERVIDORES]: setStatus,
})
